
    <div class="dialog-header-container">
        <mat-icon>check_circle_outline</mat-icon>
        <h4 mat-dialog-title>Mark as Completed</h4>
    </div>
    <div class="dialog-sub-header">
        <h4>Assignee</h4>
        <h3>M Lakshmi</h3>
    </div>
    <mat-dialog-content [ngStyle]="{'height':'500px'}">
        <div class="dialog-project-status-container">
            <!-- <ng-scrollbar #scrollable track="all" pointerEventsMethod="scrollbar" [disabled]="disabled"> -->
		
            <div class="dialog-description-section">
                <h2>Task Title Detail</h2>
            </div>
            <div class="dialog-sub-description-section">
                <textarea class="textarea">

                </textarea>
            </div>
            <div>
                <input type = "text" value = {{currentDate}}/>
            </div>
            <!-- </ng-scrollbar> -->
        </div>
    </mat-dialog-content>
    <div>
        <button mat-raised-button class="button-dialog">Delete Task</button>
        <button mat-raised-button class="button-dialog">Save</button>
    </div>
